import styled from "styled-components";

export const ChangePasswordWrapper = styled.div`
  button {
    margin-top: 20px;
  }
`;